<div class="container">
  <div class="header-navbar">
    <a class="logo" [routerLink]="['/']" aria-label="Busy Guys home">
      <img class="logo-mark" src="assets/brand/inquee-logo.svg" alt="" />
    </a>
    <div class="link-container">
      <div class="button-holder">
        <app-secondary-button *ngIf="!isLoggedIn && showCreateSignUpButtons" [routerLink]="['/sign-in']"
          label="{{'general.signin' | translate}}"></app-secondary-button>
    
      </div>
      <app-flag></app-flag>
      <app-notification class="dropdown notification-box" *ngIf="isLoggedIn"></app-notification>

      <div class="dropdown" *ngIf="isLoggedIn">
        <button type="button" class="profile-trigger dropdown-toggle" id="profileMenu" data-bs-toggle="dropdown"
          aria-expanded="false">
          <div class="avatar-container">
            <app-avatar-photo [photo]="currentUser?.avatarPath" [firstname]="currentUser?.firstName"></app-avatar-photo>
          </div>
        </button>
        <div class="dropdown-menu" aria-labelledby="profileMenu">
          <a class="dropdown-item body14" *ngIf="userActiveType === 'Business'" routerLink="/business/settings">
            {{'general.settings' | translate}}
          </a>
          <a class="dropdown-item body14" routerLink="/profile" *ngIf="userActiveType === 'Customer'">
            {{'general.account_settings' | translate}}
          </a>
          <a class="dropdown-item body14" routerLink="/profile/appointments" *ngIf="userActiveType === 'Customer'">
            {{'general.appointments' | translate}}
          </a>
          <a class="dropdown-item body14" *ngIf="currentUser.userType === 'Business'" (click)="switchAccount()">
            {{'general.switch_account' | translate}}
          </a>
          <button class="dropdown-item body14 danger-item" type="button" (click)="logout()">
            {{'general.sign_out' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <app-spinner></app-spinner> -->
<!-- <stripe-pricing-table pricing-table-id="prctbl_1LcFQ7AGGNbwfazijzDLbd4q"
publishable-key="pk_test_51LP1YiAGGNbwfazi73tBrO4lwrkx3tnuYKA96WMrbxIv0q0S2cwNArqM6HiM61DjcsxrOienaOnIRiuKwNllWYve00hwqdIEi2" userId>
</stripe-pricing-table> -->
